import * as React from 'react';
import { SVGProps } from 'react';

const IconPictureSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M22 19.778V4.222C22 3 21 2 19.778 2H4.222C3 2 2 3 2 4.222v15.556C2 21 3 22 4.222 22h15.556C21 22 22 21 22 19.778ZM8.111 13.667l2.778 3.344L14.778 12l5 6.667H4.222l3.89-5Z" />
  </svg>
);
export default IconPictureSizeM;
